import { Button } from '@/components/Button/Button';
import { t } from '@/lib/i18n';
import type { Connector } from '../schemas';
import styles from './ConnectorCard.module.css';

interface Props {
  connector: Connector;
  onConnect: (id: string) => void;
  onDisconnect: (id: string) => void;
  onManageGrants: (id: string) => void;
}

const STATUS_LABELS: Record<string, string> = {
  connected: 'Connected',
  not_connected: 'Not connected',
  error: 'Reconnect needed',
};

export function ConnectorCard({ connector, onConnect, onDisconnect, onManageGrants }: Props) {
  const status = connector.config?.status ?? 'not_connected';
  const statusClass = status.replace(/_/g, '-');
  return (
    <article className={`${styles.card} ${styles[statusClass]}`}>
      <header className={styles.header}>
        <div className={styles.meta}>
          <h3 className={styles.name}>{connector.name}</h3>
          <span className={`${styles.badge} ${styles[`badge-${statusClass}`]}`}>
            {STATUS_LABELS[status]}
          </span>
        </div>
        {status === 'connected' && connector.config?.connectedAt && (
          <p className={styles.attribution}>
            {t('Connected')} {new Date(connector.config.connectedAt).toLocaleDateString()}
          </p>
        )}
      </header>
      <div className={styles.actions}>
        {status === 'connected' && (
          <>
            <Button variant="secondary" size="sm" onClick={() => onManageGrants(connector.id)}>
              {t('Manage grants')}
            </Button>
            <Button variant="danger" size="sm" onClick={() => onDisconnect(connector.id)}>
              {t('Disconnect')}
            </Button>
          </>
        )}
        {status === 'not_connected' && (
          <Button variant="primary" size="sm" onClick={() => onConnect(connector.id)}>
            {t('Connect')}
          </Button>
        )}
        {status === 'error' && (
          <Button variant="primary" size="sm" onClick={() => onConnect(connector.id)}>
            {t('Reconnect')}
          </Button>
        )}
      </div>
    </article>
  );
}
